export const purchaseDraftPrefix = (tenantId, userId) =>
  `pos_purchase_draft:${tenantId}:${userId}:`;

export function readPurchaseDrafts(prefix) {
  const drafts = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key?.startsWith(prefix)) continue;
    try {
      const draft = JSON.parse(localStorage.getItem(key));
      if (draft?.version === 1 && draft.id && key === prefix + draft.id && typeof draft.updatedAt === "string" && Array.isArray(draft.lines)) drafts.push(draft);
    } catch { /* A damaged entry must not hide other recoverable drafts. */ }
  }
  return drafts.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}

export function writePurchaseDraft(prefix, draft) {
  localStorage.setItem(prefix + draft.id, JSON.stringify({ ...draft, version: 1, updatedAt: new Date().toISOString() }));
}

export function removePurchaseDraft(prefix, id) {
  localStorage.removeItem(prefix + id);
}
